import { useBookmarksContext } from "@/stores/bookmark";
import { useDataflowStore } from "@/stores/dataflow";
import { useUserFiles } from "@/stores/user-file";
import { useMemo } from "react";

/**
 * Hook to check if the active dataflow has a data input selected and properly configured
 * @returns true if a data input (data_input or user_file) is present and configured in the flow
 * @deprecated
 */
export function useHasDataInput(): boolean {
  const activeDataflowId = useDataflowStore((state) => state.activeDataflowId);
  const flowDefinitionJson = useDataflowStore((state) => {
    if (!state.activeDataflowId) return undefined;
    return state.dataflows[state.activeDataflowId]?.flow_definition_json;
  });
  const userFiles = useUserFiles();
  const { getBookmarkFromTableId } = useBookmarksContext();

  const result = useMemo(() => {
    if (!activeDataflowId) {
      return false;
    }

    if (!flowDefinitionJson) {
      return false;
    }

    const dataInput = flowDefinitionJson.find(
      (transformer) =>
        transformer.type === "data_input" || transformer.type === "user_file"
    );

    if (!dataInput) {
      return false;
    }

    let isConfiguredAndAvailable = false;

    if (dataInput.type === "data_input") {
      const dbTableId = (dataInput as any).db_table_id;
      if (dbTableId) {
        const bookmark = getBookmarkFromTableId(dbTableId);
        isConfiguredAndAvailable = !!bookmark;
      }
    } else if (dataInput.type === "user_file") {
      const fileId = (dataInput as any).file_id;
      if (fileId) {
        const file = userFiles.find((f) => f.id === fileId);
        isConfiguredAndAvailable = !!file;
      }
    }

    return isConfiguredAndAvailable;
  }, [activeDataflowId, flowDefinitionJson, userFiles, getBookmarkFromTableId]);

  return result;
}
